import { getUniqId, isLoadInIFrame } from "../helpers";
import { StateOption } from "../types";
import { ADMIN_MODAL_STEP } from "../enums/admin_modal_step";

declare var SatisfiApp;

export const states: StateOption = {
  apiServer: "https://api.satisfitest.us",
  companyId: 0,
  companyToken: " ",
  extBotId: 0,
  convId: "",
  userId: "",
  cfHeader: "",
  messages: [],
  isBotHasAvatar: false,
  avatarSrc: "",
  isConfigurationLoaded: false,
  maintainState: false,
  sendMsgUrl: "",
  prefixClassName: "satisfi_",
  showInfoPanel: false,
  errorMessage: null as any,
  showTypingIndicator: false,
  showProcessingMessage: false,
  processingDisplayIcon: "",
  processingDisplayText: "",
  pageId: "",
  socketId: getUniqId(),
  lastMessageId: null,
  shouldShowBanner: false,
  isAppInAdaMode: false,
  retryWarningCount: 10,
  retryInterval: 10,
  isIFrameLoaded: isLoadInIFrame(),
  isShowHeaderInIframe: true,
  isHideTitleBar: false,
  satisfiURL: "",
  headerImage: "",
  backgroundImage: "",
  headerImageDestinationURL: "",
  headerImageDestTrackingURL: "",
  isBrowseUrlOnSametab: false,
  typingMessageSecondsInterval: 10,
  typingType: 0,
  isUserHasAvatar: false,
  AWSServerURL: "",
  AWSThemeFilePath: "",
  AWSImageLogoPath: "",
  AWSPopupConfigPath: "",
  popupId: "0",
  pageReferralUrl: "",
  disableInput: false,
  defaulthideInputContainerSetting: false,
  lastFocusableElement: {},
  bannerText: "",
  userLat: "",
  userLng: "",
  locationBlocked: false,
  userIdSourceTypeId: 0,
  parentSiteUrl: "",
  parentSiteReferralUrl: "",
  requestResponseReceived: true,
  focusedWindow: true,
  isSignalRConnected: false,
  isAnchorTagClickedSametabNewtab: false,
  clientVersion: "",
  minimumClientVersion: "",
  isTilesOpenedInIframe: false,
  showAdminLoginModal: false,
  // SD-13787: step the admin modal opens on, so the footer can seed it before the
  // modal mounts instead of emitting an event into a component that may not exist yet.
  adminModalStep: ADMIN_MODAL_STEP.Login,
  showConsentModal: false,
  showTranscriptModal: false,
  isAdminMode: false,
  enableAdminMode: false,
  webApiAddress: "",
  dashboardAddress: "",
  attemptNoofInvalidCode: 5,
  attemptNoofResendCode: 5,
  mfaExpiration: 30,
  mfaEnableDateTime: "",
  authToken: "",
  authTokenExpiration: 60,
  isMFAEnabled: false,
  refreshTask: null,
  isTermsConsentEnabled: false,
  isFirstUserMessage: true,
  isTermsOfServiceAccepted: false,
  termsConsentPayload: "",
  termsConsentExpiration: "0",
  consentStatusOptions: null,
  formInputs: [],
  showWelcomeBanner: false,
  isNewMessageProcessing: false,
  isMaintainStateMessages: false,
  enableMessageNavigation: false,
  pageConfig: {
    inputContainerPlaceholderText: "",
    messageTimeFormat: "",
    sendingIndicatorText: "",
    taglineText: "",
  },
  isMessagesRestored: false,
  carouselModalDetail: null,
  carouselModalList: null,
  clientSiteLanguage: null,
  baseInlineActionUrl: "",
	taglineUrl: "",
	isStreamingMessages: false,
	shouldSkipDefaultScroll: false,
	maintainStateQueue: [],
	isWelcomeMessageProcessed: false,
  feedbackCooldowns: {},
  feedbackTexts: {},
  feedbackDownButtonLabels: [],
  feedbackClickCooldownSeconds: 0,
  screenReaderAnnouncement: "",
	lastFocusedElement: null as HTMLElement | null,
  pageStatusId: 1,
  senderDisplayName: "",
  senderLiveDisplayName: "",
  aiAgentAvatarUrl: "",
  liveAgentAvatarUrl: "",
  suppressNextScroll: false,
  sessionId: "",
  skipWelcomeMessageOnURLInput: false,
  isStreamingPages: false,
	lastScrollPosition: "",
	viewPointHeight: 0,
	incomingScrollPosition: "",
  piiSensitivity: "normal",
  inLineClickedURL: "",
  iOSInputFontFix: false,
  thumbsUpResponse: "",
  thumbsDownResponse: "",
  showTrafficStatusBar: false,
  trafficStatusText: "",
  carouselButtonClicked: false
};
